module.exports = __webpack_public_path__ + "img/infographic-t-shirt.fa004ade.svg";